module.exports = __webpack_public_path__ + "img/ciphertext_pattern.3cd25dbf.png";